<template lang="pug">
  .auth.main
    img.auth__logo(alt="Vue logo" :src="require(`@/assets/img/${logo}`)")

    router-view(:key="$route.fullPath")
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      logo: 'logo.svg',
    };
  },

  computed: {
    ...mapGetters({
      appMode: 'globalModule/getAppMode',
    }),
  },

  watch: {
    appMode(newValue) {
      this.setLogo(newValue);
    },
  },

  methods: {
    setLogo(mode) {
      switch (mode) {
        case 'DEV':
          this.logo = 'logoDEV.svg';
          break;
        case 'PRE':
          this.logo = 'logoPRE.svg';
          break;
        default:
          this.logo = 'logo.svg';
          break;
      }
    },
  },

  created() {
    this.setLogo(this.appMode);
  },
};
</script>
